import angular from 'angular';
import 'angular-legacy-sortablejs-maintained';

import CalendarListComponent from './calendar-list.cmpt';

export default angular
    .module('application.scene.authorized.scene.calendar.component.calendar-navigation.component.calendar-list', [
        'ng-sortable'
    ])
    .component(CalendarListComponent.selector, CalendarListComponent);



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-navigation/component/calendar-list/index.js